import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsButtonModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsLazyI18nModule } from '../../i18n/i18n.module';

import { HudComponent } from './hud.component';
import { TranslationIdMap } from './hud.component.i18n';

@NgModule({
    declarations: [HudComponent],
    exports: [HudComponent],
    imports: [
        CmpsButtonModule,
        CmpsDialogModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsTooltipModule,
        CommonModule,
    ],
})
export class CmpsLocalCallHudModule {}
